module.exports = __webpack_public_path__ + "893b5a7253da64cebfe6793cf72744d0.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/gabriel-main-1080.webp
// module id = 321
// module chunks = 0